<template>
  <ul class="tree">
    <li v-for="item in data" :key="item.id">
      <div class="title">
        <van-checkbox @click="changeCheckBox(item)" v-model="item.checked"></van-checkbox>
        <span @click="openItem(item)">{{ item.name }}</span>
        <template v-if="item.hasNext">
          <van-icon v-if="!item.defaultOpen" name="arrow-down" />
          <van-icon v-else name="arrow-up" />
        </template>
      </div>
      <template v-if="item.children && item.children.length && item.defaultOpen">
        <tree @open="open" @choose="choose" :data="item.children"></tree>
      </template>
    </li>
  </ul>
</template>

<script>
import tree from '@/components/tree'
export default {
  name: 'tree',
  components: {
    tree
  },
  props: {
    data: {
      type: Array
    }
  },
  methods: {
    openItem(item) {
      if (item.hasNext) {
        this.open(item)
      }
    },
    open(item) {
      this.$emit('open', item)
    },
    choose(item) {
      this.$emit('choose', item)
    },
    changeCheckBox(item) {
      this.choose(item)
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  transition: all 0.3s linear;
  padding: 10px 0 10px 0;
  padding-left: 20px;
}

ul > li {
  padding: 4px 0;
}
.title {
  display: flex;
  align-items: center;
  span {
    flex: 1;
    padding-left: 10px;
  }
}
</style>
<style lang="scss">
.tree .van-checkbox {
  display: inline-block;
  vertical-align: middle;
}
</style>
